import classNames from 'classnames';
import { useContext, useState } from 'react';
import { SaveTemplatePopupContext } from '../contextProvider';
import { SAVE_TEMPLATE_PAGE } from '../types';
import ButtonAccent from '../../../sharedComponents/Button/ButtonAccent';
import ImageOrImg from '../../ImageOrImg';

function UpdateExisting() {
  const [loading, setloading] = useState(false);
  const {
    err, setstep, templateToUpdate, onUpdateTemplate,
  } = useContext(SaveTemplatePopupContext);

  const updateTemplate = async () => {
    setloading(true);

    await onUpdateTemplate();
    setloading(false);
  };

  return (
    <div>
      <div
        className="is-subtitle mb-4 with-cursor-pointer"
        role="none"
        onClick={() => { setstep(SAVE_TEMPLATE_PAGE.EXISTING_OR_NEW); }}
      >
        &larr; Back
      </div>
      <div className={classNames('is-size-5 with-text-color mb-3')}>
        Update Template
      </div>
      <div className="is-subtitle mb-6">You&apos;re going to update the contents of this template</div>

      <div className="box-border has-fit-content-width p-0">
        <ImageOrImg
          src={templateToUpdate.preview}
          width={220}
          height={110}
          objectFit="cover"
          alt={templateToUpdate.name}
        />
      </div>
      <div className="with-text-color is-size-5 mb-2 mt-3">
        {templateToUpdate.name}
      </div>
      <div className="is-subtitle mb-6">
        {templateToUpdate.description}
      </div>

      <ButtonAccent
        className="mt-5"
        onClick={updateTemplate}
        loading={loading}
      >
        Update this template
      </ButtonAccent>
      {err && <div className="with-danger-text-color">{err}</div>}
    </div>
  );
}

export default UpdateExisting;
